/**
 * Per-block table index for the bridge init payload — blocks whose type
 * carries a Fields `table` attribute get in-place cell editing on the
 * canvas. Mirrors inlineMap.ts.
 */

import type { InitPayload } from './protocol';
import type { BlockNode } from './types';
import { isSharedBlock, markerId } from './types';
import type { TypeInfo } from './useBuilderRegistry';

export function buildTableIndex(content: BlockNode[], types: TypeInfo[]): NonNullable<InitPayload['tables']> {
    const byType = new Map(types.map((type) => [type.slug, type]));
    const index: NonNullable<InitPayload['tables']> = {};

    const visit = (blocks: BlockNode[]): void => {
        for (const block of blocks) {
            const id = markerId(block);
            const type = isSharedBlock(block) ? undefined : byType.get(String(block.type));
            const attr = type?.attributes?.find((attribute) => attribute.type === 'table');

            if (id !== null && attr) {
                index[id] = { attr: attr.slug };
            }

            if (block.children?.length) {
                visit(block.children);
            }
        }
    };

    visit(content);

    return index;
}
